export const request = {
  PENDING: 'pending',
  INIT: 'init',
  RESOLVED: 'resolved',
  REJECTED: 'rejected'
};

export const emailVerification = {
  VERIFIED: 'VERIFIED',
  UNVERIFIED: 'UNVERIFIED',
  GRACE_PERIOD: 'GRACE_PERIOD'
};